import { createContext, useContext } from 'react';

const ClubContext = createContext<string | undefined>(undefined);

export const useClubContext = () => {
    const context = useContext(ClubContext);

    if (context === null) {
        throw new Error('useClubContext must be used within a ClubContext.Provider');
    }

    return context;
};

export default ClubContext;
